import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/home-notes-images.png")